const BranchIcon = () => (
    <svg
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        viewBox="0 0 22 22"
        width="1.042vw"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(-152 -64)">
            <path d="m159 71.829v8.342c-1.165.412-2 1.524-2 2.829 0 1.656 1.344 3 3 3s3-1.344 3-3c0-1.305-.835-2.417-2-2.829v-1.171h4c2.209 0 4-1.791 4-4v-1.171c1.165-.412 2-1.524 2-2.829 0-1.656-1.344-3-3-3s-3 1.344-3 3c0 1.305.835 2.417 2 2.829v1.171c0 1.105-.895 2-2 2h-4v-5.171c1.165-.412 2-1.524 2-2.829 0-1.656-1.344-3-3-3s-3 1.344-3 3c0 1.305.835 2.417 2 2.829zm1 10.171c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm8-12c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-8-2c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" />
        </g>
    </svg>
);

export default BranchIcon;